import { useQuery } from 'react-query'

import type { TrendDetectionService } from 'features/trend-detection/service/service'
import type { IssueAgentRunResponse } from 'features/trend-detection/types'

export interface UseAgentRunsResult {
  runs: IssueAgentRunResponse[]
  isLoading: boolean
  isError: boolean
}

export function useAgentRuns(
  service: TrendDetectionService,
  projectId: string | null,
  agentUuid: string | null,
): UseAgentRunsResult {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['trend-agent-runs', projectId, agentUuid],
    queryFn: async () => {
      if (!projectId || !agentUuid) throw new Error('missing')
      return service.fetchAgentRuns(projectId, agentUuid)
    },
    enabled: !!projectId && !!agentUuid,
  })
  return {
    runs: data ?? [],
    isLoading,
    isError,
  }
}
